import React from 'react';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { Button, Form, Modal } from 'antd';
import { useSaveMealPlan } from 'hooks';

import { TMealPlanFormData } from 'interfaces/mealPlan';

import MealPlanForm from './components/MealPlanForm';
import { PageWrapper } from './styles';

const { useForm } = Form;

const MealPlanAddPage = () => {
  const navigate = useNavigate();
  const [form] = useForm();
  const { mutateAsync: saveMealPlan } = useSaveMealPlan();

  const handleSubmit = async (values: TMealPlanFormData) => {
    const { mealPlanImage, serveDate, ...other } = values;
    const items = other?.isUseMealPlanItem ? other?.items : [];
    const request = JSON.stringify({ ...other, serveDate: moment(serveDate).format('YYYY-MM-DD'), items });

    const formData = new FormData();
    formData.append('request', new Blob([request], { type: 'application/json' }));
    formData.append('mealPlanImage', mealPlanImage);

    await saveMealPlan(formData);
    Modal.info({
      className: 'info-handler-modal',
      content: `식단표가 등록되었습니다.`,
      icon: null,
      okText: '확인'
    });
    navigate('/mealPlan');
  };

  return (
    <PageWrapper>
      <MealPlanForm form={form} onSubmit={handleSubmit}>
        <div style={{ display: 'flex', gap: '16px', justifyContent: 'end', marginTop: '24px' }}>
          <Button className="default-button-style">취소</Button>
          <Button className="default-button-style" type="primary" htmlType="submit">
            저장하기
          </Button>
        </div>
      </MealPlanForm>
    </PageWrapper>
  );
};

export default MealPlanAddPage;
